import { gql } from '@apollo/client';

export const fetchProductsAndLinkedEntitlements = gql`
  query fetchProductsAndLinkedEntitlements(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
    $searchLinkedEntitlementParams: SearchLinkedEntitlementParams
  ) {
    transactionAccount(id: $id) {
      id
      productSubscriptionsInPPC(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          id
          productId
          offeringId
          productName
          isSandbox
          relatesFromEntitlements {
            relationshipType
            entitlementId
          }
          relatesToEntitlements {
            relationshipType
            entitlementId
          }
          linkedEntitlements(searchLinkedEntitlementParams: $searchLinkedEntitlementParams) {
            entitlementId
            productId
            productName
            offeringId
            subscriptionId
            isApp
            transactionAccountId
            billingGroupId
            edition
            isSandbox
            billingStatus
            relatesFromEntitlements {
              entitlementId
              relationshipType
            }
          }
        }
      }
    }
  }
`;
